import { createFileRoute } from "@tanstack/react-router";
import { Notes } from "../../app/views/trikin/notes";

export const Route = createFileRoute("/trikin/notes")({
  component: Notes,
});
